<template>
  <div class="style-quiz-back-wrapper">
    <div class="style-quiz-back">
      <button class="prev" @click="exitStyleQuiz">
        <img
          src="@/assets/icons/left.svg"
          :alt="$t('project_details.proposal.slider_arrow_left_alt')"
        />
        <span>{{ $t("style_quiz.go_back") }}</span>
      </button>
    </div>
  </div>

  <create-project-steps-menu :current-step="1"></create-project-steps-menu>

  <div class="client-selection loader-block-parent">
    <div v-show="isLoading" class="loader-block">
      <div>
        <div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
    <p class="client-selection__heading">
      {{ $t("style_quiz.profile.select_profile") }}
    </p>
    <div class="client-selection__inner">
      <div
        class="client-selection__left client-selection__option"
        :class="{
          active: selectedProfile === RETAIL_TYPE,
        }"
        @click.prevent="toggleProfileType(RETAIL_TYPE)"
      >
        <div class="client-selection__box">
          <div
            class="indicator"
            :class="{
              checked: selectedProfile === RETAIL_TYPE,
            }"
          ></div>
          <img
            src="@/assets/icons/retail-person.svg"
            :alt="$t('style_quiz.profile.retail_img')"
          />
          <p>{{ $t("style_quiz.profile.retail") }}</p>
        </div>
        <p class="client-selection__text">
          {{ $t("style_quiz.profile.retail_desc") }}
        </p>
      </div>
      <div
        class="client-selection__right client-selection__option"
        :class="{
          active: selectedProfile === BUSINESS_TYPE,
        }"
        @click.prevent="toggleProfileType(BUSINESS_TYPE)"
      >
        <div class="client-selection__box">
          <div
            class="indicator"
            :class="{
              checked: selectedProfile === BUSINESS_TYPE,
            }"
          ></div>
          <img
            src="@/assets/icons/suitcase.svg"
            :alt="$t('style_quiz.profile.business_img')"
          />
          <p>{{ $t("style_quiz.profile.business") }}</p>
        </div>
        <p class="client-selection__text">
          {{ $t("style_quiz.profile.business_desc") }}
        </p>
      </div>
    </div>
  </div>
  <div class="buttons">
    <button @click.prevent="exitStyleQuiz" class="back">
      {{ $t("style_quiz.profile.skip") }}
    </button>
    <button
      class="next"
      @click.prevent="submitProfile"
      :class="{ disabled: sendingForm }"
      :disabled="sendingForm"
    >
      <template v-if="!sendingForm">
        {{ $t("style_quiz.profile.next") }}
      </template>
      <template v-else> {{ $t("style_quiz.profile.next") }}... </template>
    </button>
  </div>
</template>

<script>
import CreateProjectStepsMenu from "@/components/createProject/CreateProjectStepsMenu";
import { inject, ref } from "vue";
import { useI18n } from "vue-i18n";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import router from "@/router";
import authHelper from "@/helpsers/auth.helper";
import AlertHelper from "@/helpsers/alert.helper";
export default {
  name: "CreateProjectProfile",
  components: { CreateProjectStepsMenu },
  setup() {
    let selectedProfile = ref("");
    const RETAIL_TYPE = "RETAIL";
    const BUSINESS_TYPE = "BUSINESS";
    let alert = inject("alert");
    const { t } = useI18n();
    const sendingForm = ref(false);
    let isLoading = ref(false);

    async function fetchClientProfile() {
      isLoading.value = true;
      axios
        .get(
          ApiHelper.getProjectDetailsUrl(router.currentRoute.value.params.id),
          {
            headers: authHelper.authHeader(),
          }
        )
        .then((result) => {
          selectedProfile.value = result?.data?.typeOfClient ?? "";
          isLoading.value = false;
        })
        .catch((errorResponse) => {
          if (errorResponse?.response?.data?.code == "404")
            router.push({ path: "/not-found" });
          isLoading.value = false;
        });
    }
    fetchClientProfile();

    function toggleProfileType(type) {
      if (selectedProfile.value === type) selectedProfile.value = "";
      else selectedProfile.value = type;
    }

    function goBack() {
      router.back();
    }

    const submitProfile = async () => {
      if (
        selectedProfile.value !== RETAIL_TYPE &&
        selectedProfile.value !== BUSINESS_TYPE
      ) {
        AlertHelper.show(
          alert,
          t("style_quiz.profile.select_profile"),
          "",
          "info"
        );
      } else {
        sendingForm.value = true;
        const data = {
          id: router.currentRoute.value.params.id,
          typeOfClient: selectedProfile.value,
        };

        axios
          .put(ApiHelper.getEditProjectUrl(), data, {
            headers: authHelper.authHeader(),
          })
          .then((result) => {
            sendingForm.value = false;
            router.push({
              name: "create-project-rooms",
              params: {
                id: router.currentRoute.value.params.id,
                type: selectedProfile.value,
              },
            });
          })
          .catch(({ response }) => {
            sendingForm.value = false;
            let errorMessage = ApiHelper.getResponseMessage(
              response?.data?.code
            );
            AlertHelper.show(alert, errorMessage, "", "error");
          });
      }
    };

    function exitStyleQuiz() {
      router.push({
        name: "project-details",
        params: {
          id: router.currentRoute.value.params.id,
          activeTab: "styleQuiz",
        },
      });
    }

    return {
      selectedProfile,
      RETAIL_TYPE,
      BUSINESS_TYPE,
      toggleProfileType,
      submitProfile,
      goBack,
      sendingForm,
      exitStyleQuiz,
      isLoading,
    };
  },
};
</script>

<style scoped lang="scss">
@use "@/css/quiz";
@use "@/css/custom-quiz";

.client-selection {
  .indicator {
    &.checked {
      background-color: #f4f3f3;
      border: 0;
      background-image: url("./../../assets/icons/checkmark-dark.svg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: 70%;
    }
  }

  &__inner {
    @media screen and (max-width: 360px) {
      flex-wrap: wrap;
      gap: 20px;
    }
  }
  &__text {
    @media screen and (max-width: 360px) {
      height: auto;
    }
  }
  &__left {
    @media screen and (max-width: 360px) {
      margin-right: 0;
    }
  }
  &__box {
    @media screen and (max-width: 767px) {
      height: 130px;
    }
  }
}
</style>